import styled from 'styled-components';

export const ButtonColumn = styled.div`
  width: 100%;
  margin: auto 15px;
  align-items: center;
`;
